// const neoApiEndpoint = 'http://ec2-13-127-188-195.ap-south-1.compute.amazonaws.com:8080';
// const neoApiEndpoint = 'http://ec2-13-204-40-251.ap-south-1.compute.amazonaws.com:8080';
// const neoApiEndpoint = "http://localhost:8080";
// const neoApiEndpoint = "http://13.234.120.248:8080"; // SM Portal
// const neoApiEndpoint = "http://13.202.238.22:8080"; // Production Frappe Machine
// const neoApiEndpoint = "https://fm.wateronneo.com/api";// Production Frappe Machine , HTTPS with domain name , depricated 
const neoApiEndpoint = "https://api.wateronneo.com/v1/"; // Production Frappe Machine , HTTPS with domain name
// const neoApiEndpoint = "https://dev.wateronneo.com/v1/"; // SM Portal Machine , HTTPS with domain name

let savedMembers = [];
let isRedirectingToLogin = false;


const NeoAPI = {
  apiCount: 0,
  lastSynced: 0,
  token: localStorage.getItem("fmsToken") || null,
  // token: null,
  propertyData: null,

  _formatDate(date) {
    return date
      .toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      })
      .replace(/\//g, "-");
  },

  _formatUnixTime(
    epoch,
    options = {
      hour12: true,
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }
  ) {
    const date = new Date(epoch * 1000);
    return date
      .toLocaleString("en-US", options)
      .replace(",", "")
      .replace(
        /(\d+)\/(\d+)\/(\d+)/,
        (_, m, d, y) => `${y}-${m.padStart(2, "0")}-${d.padStart(2, "0")}`
      );
  },

  async _handleApiResponse(response, requestName) {
    if (!response.ok) {
      console.error(`[API] HTTP error ${response.status} for '${requestName}'`);
      return { status: "fail", reason: `HTTP error ${response.status}` };
    }
    try {
      // return await response.json();
      const data = await response.json();
      if (
        data?.status === "fail" &&
        data?.reason?.toLowerCase().includes("unauthorized")
      ) {
        this._handleUnauthorized();
      }

      return data;
    } catch (err) {
      console.error(`[API] Invalid JSON for '${requestName}':`, err);
      return { status: "fail", reason: "Invalid JSON response" };
    }
  },

  _handleUnauthorized() {
    // if (isRedirectingToLogin) return;
    // if (window.location.hash.includes("/login")) return;

    // isRedirectingToLogin = true;

    localStorage.clear();
    this.token = null;
    window.location.replace("/#/login");
    // setTimeout(() => {
    //   window.location.replace("/#/login");
    // }, 100);
  },

  _parseResidentsCSV(csvStr) {
    const lines = csvStr.trim().split("\n");
    const headers = lines[0].split(",");

    const data = [];
    for (let i = 1; i < lines.length; i++) {
      const values = lines[i].split(",");
      const entry = {};
      for (let j = 0; j < headers.length; j++) {
        entry[headers[j].trim()] = values[j]?.trim() || "";
      }
      data.push(entry);
    }
    let residentsArr = data;

    residentsArr = residentsArr.map(r => ({
      ...r,
      phone: r.phone.replace(/^\+/, "")
    }));

    return residentsArr;
  },
  _getMeterDetailsForUnit(unitName) {
    const units = this.propertyData?.units || {};
    const unit = units[unitName];

    if (!unit || !unit.meterLocations) {
      return { meterIds: [], meterIdMap: {} };
    }

    const meterIds = [];
    const meterIdMap = {};

    for (const location in unit.meterLocations) {
      const meter = unit.meterLocations[location];
      meterIds.push(meter.mid);
      meterIdMap[meter.mid] = location;
    }

    return {
      meterIds,
      meterIdMap, // meterId => location
    };
  },

  async post(request, parameters = {}) {
    this.apiCount = this.apiCount + 1
    console.log(`[API][API_COUNT] ${this.apiCount}`);
    const { timeout = 60000, ...rest } = parameters; // default timeout: 30s
    const req = { request, ...rest, token: this.token };

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), timeout);

    const start = performance.now();
    try {
      const response = await fetch(neoApiEndpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(req),
        signal: controller.signal,
      });

      clearTimeout(timeoutId);

      const end = performance.now();
      console.log(`[API] ${request} - ${((end - start) / 1000).toFixed(2)}s`);

      return this._handleApiResponse(response, request);

    } catch (err) {
      clearTimeout(timeoutId);

      console.error(`[API] ${request} failed`, err);

      if (err.name === "AbortError") {
        return { status: "fail", reason: "Request timed out" };
      }

      return { status: "fail", reason: "Network error" };
    }
  },

  async login(userName, passWord) {
    // const start = performance.now();
    const loginResp = await this.post("Login", { userName, passWord });
    if (loginResp.status !== "ok") {
      return { status: "fail", reason: loginResp.reason || "Login failed" };
    }

    localStorage.setItem("fmsToken", loginResp.token);

    this.token = loginResp.token || localStorage.getItem("fmsToken");
    this.lastSynced = 0;

    const property = loginResp.properties.at(-1); // last property

    const data = this._getUnits(property);
    return data;

  },

  async _getUnits(property) {
    const start = performance.now();
    const unitsResp = await this.post("Units", { property: property.property });
    if (unitsResp.status !== "ok") {
      return { status: "fail", reason: unitsResp.reason };
    }

    const unitsRaw = unitsResp.units;
    const structuredUnits = {};
    const mPoints = [],
      meterIds = [];

    for (const unitName in unitsRaw) {
      structuredUnits[unitName] = { meterLocations: {}, residents: [] };

      for (const loc in unitsRaw[unitName]) {
        const meter = unitsRaw[unitName][loc];
        const hasValve = meter.has_valve !== undefined ? meter.has_valve : 0;

        structuredUnits[unitName].meterLocations[loc] = {
          mid: meter.mid,
          mpid: meter.mpid,
          has_valve: hasValve,
        };

        mPoints.push(meter.mpid);
        meterIds.push(meter.mid);
      }
    }

    const now = new Date();
    const isFirstOfMonth = now.getDate() === 1;

    const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
    const endOfYesterday = new Date(now);
    endOfYesterday.setDate(endOfYesterday.getDate() - 1);

    const dateFrom = Math.floor(startOfMonth.getTime() / 1000);
    const dateTo = Math.floor(endOfYesterday.getTime() / 1000);

    // ⏱ Run essential API calls in parallel (Now includes Batched Daily Consumption)
    const [
      residentsResp,
      todayResp,
      dailyResp,
      alertCurrentList,
    ] = await Promise.all([
      this.post("Residents", {
        unitName: "",
        property: property.property,
        token: this.token,
      }),

      this._fetchTodaysConsumptionBatched(
        meterIds,
        property.property,
        this.token,
        400
      ),

      !isFirstOfMonth
        ? this._fetchDailyConsumptionBatched(
          mPoints,
          property.property,
          this.token,
          dateFrom,
          dateTo,
          500
        )
        : Promise.resolve({ status: "skipped", Consumption: {} }),

      // 🔁 Use _fetchAlerts instead of raw POSTs
      this._fetchAlerts(meterIds, property.property, "current"),
    ]);

    // 🚀 Background Call: Alert History (Still backgrounded for speed)
    this._fetchAlerts(meterIds, property.property, "history")
      .then((history) => {
        if (this.propertyData) {
          this.propertyData.alerts = history;
          console.log("[Background] Alert history loaded.");
        }
      })
      .catch((err) => console.error("Background Alert History failed:", err));

    const endMid = performance.now();
    console.log(
      `[API] Login After Essential API calls Success - ${(
        (endMid - start) /
        1000
      ).toFixed(2)}s`
    );

    this._attachResidents(residentsResp, structuredUnits);

    // ✅ Attach today's consumption
    if (todayResp.status === "ok") {
      this._attachTodaysConsumptionToUnits(
        structuredUnits,
        todayResp.Consumption
      );
    }

    // ✅ Attach daily consumption (Now happens before login returns)
    if (dailyResp.status === "ok" || dailyResp.status === "skipped") {
      this._attachDailyConsumptionToUnits(
        structuredUnits,
        dailyResp.Consumption,
        startOfMonth
      );
    }

    // ✅ Final structured property data
    this.propertyData = {
      ...property,
      units: structuredUnits,
      meterIds,
      mPoints,
      alerts: [], // Background history will fill this later
      currentAlerts: alertCurrentList,
      uinfo: unitsResp.uinfo,
    };

    const end = performance.now();
    console.log(`[API] Login Total - ${((end - start) / 1000).toFixed(2)}s`);

    // const resp = await this.getWaterBillHistory(' Chelli Poise')
    // const resp2 = await this.getWaterBill(' Chelli Poise', '1A & 1B    ', '2025-09-01')
    return {
      status: "ok",
      property: property.property,
      userType: "Tenant",
      appUser: 1,
      fmUser: 1,
    };
  },
  _attachResidents(residentsResp, targetUnits) {
    if (
      residentsResp.status === "ok" &&
      residentsResp.Residents &&
      targetUnits
    ) {
      const residentsArr = this._parseResidentsCSV(residentsResp.Residents);

      // 1. Group NEW data
      const incomingMap = {};
      for (const r of residentsArr) {
        const unit = r.unit;
        if (!incomingMap[unit]) incomingMap[unit] = [];
        incomingMap[unit].push(r);
      }

      // 2. Update ONLY the units that we received data for
      // (This is safe for both Login AND Single Unit updates)
      for (const unitName in incomingMap) {
        if (targetUnits[unitName]) {
          // This line MUTATES the global propertyData object directly
          targetUnits[unitName].residents = incomingMap[unitName];
        }
      }
    }
  },
  async _fetchTodaysConsumptionBatched(
    meterIds,
    property,
    token,
    batchSize = 200
  ) {
    const start = performance.now();
    const batches = [];
    for (let i = 0; i < meterIds.length; i += batchSize) {
      batches.push(meterIds.slice(i, i + batchSize));
    }

    const requests = batches.map((batch) =>
      this.post("TodaysConsumption", { meterIds: batch, property, token })
    );

    const responses = await Promise.all(requests);

    // Merge all responses into a single structure
    const mergedConsumption = [];
    for (const resp of responses) {
      if (resp.status === "ok" && Array.isArray(resp.Consumption)) {
        mergedConsumption.push(...resp.Consumption);
      }
    }
    const endMid = performance.now();
    console.log(
      `[API] _fetchTodaysConsumptionBatched - ${(
        (endMid - start) /
        1000
      ).toFixed(2)}s`
    );
    return { status: "ok", Consumption: mergedConsumption };
  },
  async _fetchDailyConsumptionBatched(
    mPoints,
    property,
    token,
    dateFrom,
    dateTo,
    batchSize = 200
  ) {
    const start = performance.now();
    const batches = [];
    for (let i = 0; i < mPoints.length; i += batchSize) {
      batches.push(mPoints.slice(i, i + batchSize));
    }

    const requests = batches.map((batch) =>
      this.post("DailyConsumption", {
        mPoints: batch,
        property,
        token,
        dateFrom,
        dateTo,
      })
    );

    const responses = await Promise.all(requests);

    // ✅ FIX: Merge objects instead of arrays
    const mergedConsumption = {};
    for (const resp of responses) {
      if (resp.status === "ok" && resp.Consumption) {
        // Use Object.assign to merge the new batch into our main object
        Object.assign(mergedConsumption, resp.Consumption);
      }
    }

    const endMid = performance.now();
    console.log(
      `[API] _fetchDailyConsumptionBatched - ${((endMid - start) / 1000).toFixed(2)}s`
    );

    // Return the merged object inside the response structure
    return { status: "ok", Consumption: mergedConsumption };
  },

  async _fetchAndAttachDailyConsumption(
    units,
    mPoints,
    propertyName,
    token,
    startDate,
    endDate
  ) {
    const dateFrom = Math.floor(startDate.getTime() / 1000);
    const dateTo = Math.floor(endDate.getTime() / 1000) + 19801;

    const dailyResp = await this.post("DailyConsumption", {
      mPoints,
      property: propertyName,
      token,
      dateFrom,
      dateTo,
    });

    if (dailyResp.status === "ok") {
      this._attachDailyConsumptionToUnits(
        units,
        dailyResp.Consumption,
        startDate
      );
      return true;
    }
    return false;
  },

  _attachTodaysConsumptionToUnits(units, todayData) {
    const start = performance.now();
    const todayStr = this._formatDate(new Date());
    let i = 0;
    for (const unitName in units) {
      const unit = units[unitName];
      const locations = unit.meterLocations;
      for (const location in locations) {
        const meter = locations[location];
        meter.consumption = meter.consumption || {};
        meter.consumption[todayStr] = todayData[i++] || 0;
      }
    }
    console.log(
      `[API] _attachTodaysConsumptionToUnits - ${(
        (performance.now() - start) /
        1000
      ).toFixed(2)}s`
    );
  },

  _attachDailyConsumptionToUnits(units, dailyData, startDate) {
    const start = performance.now();
    for (const unitName in units) {
      const locations = units[unitName].meterLocations;
      for (const loc in locations) {
        const meter = locations[loc];
        meter.consumption = meter.consumption || {};
        const daily = dailyData[meter.mpid] || {};
        for (const offset in daily) {
          const offsetNum = parseInt(offset, 10);
          const date = new Date(startDate);
          date.setDate(startDate.getDate() + offsetNum);
          meter.consumption[this._formatDate(date)] = daily[offset];
        }
      }
    }
    console.log(
      `[API] _attachDailyConsumptionToUnits - ${(
        (performance.now() - start) /
        1000
      ).toFixed(2)}s`
    );
  },
  getPropertyData() {
    return this.propertyData || null;
  },
  getUnits() {
    const aptList = [];

    // Ensure property and units exist
    if (!this.propertyData || !this.propertyData.units) {
      return {
        response_data: {
          aptList: [],
          societyId: "UNKNOWN",
        },
        message: "Property data not loaded.",
        error: "No property data",
        status: "Fail",
      };
    }

    const units = this.propertyData.units;

    for (const unitName in units) {
      const apt = {
        aptId: unitName,
        aptNo: unitName,
        owner: "-",
        apt_bhk: null,
        noa: 0, // number of adults
        noc: 0, // number of children
        sqft: 0,
        floor: 0,
        tower: null,
        property_type: null,
        ownerEmail: units[unitName]?.residents[0]?.email,
      };

      aptList.push(apt);
    }

    return {
      response_data: {
        aptList,
        societyId: this.propertyData.property || "UNKNOWN",
      },
      message: "",
      error: "",
      status: "Success",
    };
  },
  getAppUsers(unitName) {
    const result = {
      response_data: {
        users: [],
      },
      message: "",
      error: "",
      status: "Success",
    };

    const units = this.propertyData?.units;
    if (!units || !units[unitName]) {
      result.message = "Unit not found.";
      result.error = "Invalid unit name";
      return result;
    }

    const residents = units[unitName].residents || [];

    for (const resident of residents) {
      const isAppUser = resident.appUser === "1" || resident.appUser === 1;
      if (isAppUser) {
        result.response_data.users.push({
          mobileNumber: resident.phone || "",
          mobileNo: resident.phone
            ? `91${resident.phone.replace(/^(\+91|91)?/, "")}`
            : "",
          isdCode: 91,
          aptId: unitName,
          aptNumber: unitName,
          emailID: resident.email || "",
          member_name: resident.residentName || "",
          gcmRegistration: null,
          lastLoginTime: null,
          appVisitedCount: 0,
          appType: "0",
          apns: "",
          isOwner: resident.residentType === "Owner" ? "1" : "0",
          rowId: Math.floor(Math.random() * 1000000),
        });
      }
    }

    return result;
  },

  async getDaywiseTotalUsage(fromDateStr, toDateStr, attempt = 0) {
    const defaultResp = {
      status: "Fail",
      response_data: {
        unit: "litre",
        data: [],
        societyId: this.propertyData?.societyId || "UNKNOWN",
        societyName: this.propertyData?.property || "UNKNOWN",
        totalConsumption: 0,
      },
      message: "No usage data or property info.",
      error: "Data unavailable",
    };

    if (!this.propertyData?.units) return defaultResp;

    // const start = new Date(fromDateStr);
    // const end = new Date(toDateStr);
    const [fromYear, fromMonth, fromDay] = fromDateStr.split("-").map(Number);
    const [toYear, toMonth, toDay] = toDateStr.split("-").map(Number);

    // Months in JS Date are zero-based, so subtract 1
    const start = new Date(fromYear, fromMonth - 1, fromDay, 0, 0, 0);
    const end = new Date(toYear, toMonth - 1, toDay, 0, 0, 0);

    if (isNaN(start.getTime()) || isNaN(end.getTime())) {
      return {
        ...defaultResp,
        message: "Invalid date format.",
        error: "Invalid Date",
      };
    }

    const rawTotals = {};
    for (const unitName in this.propertyData.units) {
      const unit = this.propertyData.units[unitName];
      for (const loc in unit.meterLocations) {
        const meter = unit.meterLocations[loc];
        for (const dateStr in meter.consumption || {}) {
          const [d, m, y] = dateStr.split("-").map(Number);
          const dObj = new Date(y, m - 1, d);
          if (dObj >= start && dObj <= end) {
            rawTotals[dateStr] =
              (rawTotals[dateStr] || 0) + meter.consumption[dateStr];
          }
        }
      }
    }

    if (Object.keys(rawTotals).length === 0 && attempt === 0) {
      const fetched = await this._fetchAndAttachDailyConsumption(
        this.propertyData.units,
        this.propertyData.mPoints,
        this.propertyData.property,
        this.token,
        start,
        end
      );
      if (fetched) {
        return this.getDaywiseTotalUsage(fromDateStr, toDateStr, attempt + 1);
      } else {
        return defaultResp;
      }
    }

    const sortedDates = Object.keys(rawTotals).sort((a, b) => {
      const [da, ma, ya] = a.split("-").map(Number);
      const [db, mb, yb] = b.split("-").map(Number);
      return new Date(ya, ma - 1, da) - new Date(yb, mb - 1, db);
    });

    const data = sortedDates.map((date) => {
      const [d, m, y] = date.split("-");
      return {
        date: `${y}-${m}-${d}`,
        totalQty: Math.round(rawTotals[date] / 1000),
      };
    });

    return {
      status: "Success",
      response_data: {
        unit: "litre",
        data,
        societyId: this.propertyData.property || "UNKNOWN",
        societyName: this.propertyData.property || "UNKNOWN",
        totalConsumption: data.reduce((acc, curr) => acc + curr.totalQty, 0),
      },
      message: "",
      error: "",
    };
  },

  async generateConsumptionSummary(monthYear, attempt = 0) {
    const result = {
      response_data: [],
      message: "",
      error: "",
      status: "Success",
    };

    if (!this.propertyData?.units) {
      result.status = "Fail";
      result.error = "Property data not loaded.";
      return result;
    }

    const [monthStr, yearStr] = monthYear.split("-");
    const month = parseInt(monthStr) - 1;
    const year = parseInt(yearStr);
    const start = new Date(year, month, 1);
    const end = new Date(year, month + 1, 0);

    const totalRow = { name: "-", apt: "Total", total: 0 };
    for (let i = 1; i <= 31; i++) totalRow[`con${i}`] = 0;

    let totalConsumption = 0;

    for (const unitName in this.propertyData.units) {
      const unit = this.propertyData.units[unitName];
      let userName = "";

      if (Array.isArray(unit.residents) && unit.residents.length > 0) {
        // Try to find resident with type "Owner"
        const owner = unit.residents.find((r) => r.residentType === "Tenant");

        if (owner && owner.residentName) {
          userName = owner.residentName;
        } else {
          // Fall back to first resident's name if available
          userName = unit.residents[0].residentName || "";
        }
      }

      const unitRow = { name: userName, apt: unitName, total: 0, children: [] };
      for (let d = 1; d <= 31; d++) unitRow[`con${d}`] = 0;

      const meterLocations = Object.entries(unit.meterLocations); // [ [locName, meter], ... ]

      meterLocations.forEach(([locName, meter], index) => {
        const con = meter.consumption || {};
        const meterRow = { meterId: meter.mid, location: locName, total: 0 };

        for (let d = 1; d <= 31; d++) {
          const key = `${String(d).padStart(2, "0")}-${monthYear}`;
          const col = `con${d}`;
          const value = Math.round((con[key] || 0) / 1000);
          meterRow[col] = value || "-";
          if (value) {
            meterRow.total += value;
            unitRow[col] += value;
            totalRow[col] += value;
          }
        }

        unitRow.total += meterRow.total;
        unitRow.children.push(meterRow); // Add meter row to array
      });

      for (let d = 1; d <= 31; d++) {
        const col = `con${d}`;
        if (unitRow[col] === 0) unitRow[col] = "-";
      }

      totalRow.total += unitRow.total;
      totalConsumption += unitRow.total;
      result.response_data.push(unitRow);
    }

    for (let d = 1; d <= 31; d++) {
      const col = `con${d}`;
      if (totalRow[col] === 0) totalRow[col] = "-";
    }

    result.response_data.push(totalRow);

    if (totalConsumption === 0 && attempt < 1) {
      const fetched = await this._fetchAndAttachDailyConsumption(
        this.propertyData.units,
        this.propertyData.mPoints,
        this.propertyData.property,
        this.token,
        start,
        end
      );
      if (fetched)
        return this.generateConsumptionSummary(monthYear, attempt + 1);
    }

    return result;
  },
  async _fetchAlerts(meterIds, propertyName, type) {
    const now = Math.floor(Date.now() / 1000);

    // 🔹 Case 1: Current Alerts — Batched to avoid "Request range exceeded limit"
    if (type === "current") {
      this.lastSynced = now;

      const chunkSize = 400; // Adjusted chunk size to avoid server rejection
      const meterChunks = [];
      for (let i = 0; i < meterIds.length; i += chunkSize) {
        meterChunks.push(meterIds.slice(i, i + chunkSize));
      }

      // Fire all chunks in parallel
      const requests = meterChunks.map(chunk =>
        this.post("AlertStatus", {
          meterIds: chunk,
          property: propertyName,
          token: this.token,
        })
      );

      const responses = await Promise.all(requests);
      const mergedFlow = {};

      // Merge the "Flow" objects from each response
      for (const resp of responses) {
        if (resp.status === "ok" && resp.Flow) {
          Object.assign(mergedFlow, resp.Flow);
        } else if (resp.status === "fail") {
          console.warn(`Current Alert batch failed: ${resp.reason}`);
        }
      }

      const list = [];
      for (const mid in mergedFlow) {
        const entries = mergedFlow[mid];
        for (const entry of entries) {
          list.push([mid, ...entry]);
        }
      }

      // Sort by timestamp (index 2) descending
      list.sort((a, b) => b[2] - a[2]);
      return list;
    }

    // 🔹 Case 2: History Alerts — split both by meter + time
    const monthInSeconds = 30 * 24 * 60 * 60;
    const oldestAllowed = now - 3 * monthInSeconds; // last 3 months
    const batches = [];

    // Build month windows
    let timeTo = now;
    while (timeTo > oldestAllowed) {
      const timeFrom = Math.max(timeTo - monthInSeconds, 0);
      batches.push({ timeFrom, timeTo });
      timeTo = timeFrom;
    }

    // Split meterIds into smaller chunks
    const chunkSize = 400; // Keeping consistency with current alert chunking
    const meterChunks = [];
    for (let i = 0; i < meterIds.length; i += chunkSize) {
      meterChunks.push(meterIds.slice(i, i + chunkSize));
    }

    // Combine meter and time batches
    const allRequests = [];
    for (const { timeFrom, timeTo } of batches) {
      for (const meters of meterChunks) {
        allRequests.push({ meters, timeFrom, timeTo });
      }
    }

    // Limit parallelism to avoid flooding server
    const concurrency = 10;
    const allAlerts = [];

    const runBatch = async (req) => {
      const alertResp = await this.post("AlertHistory", {
        meterIds: req.meters,
        property: propertyName,
        token: this.token,
        timeFrom: req.timeFrom,
        timeTo: req.timeTo,
      });

      if (alertResp.status === "ok" && alertResp.History) {
        const alertData = alertResp.History;
        for (const mid in alertData) {
          const entries = alertData[mid];
          for (const entry of entries) {
            allAlerts.push([mid, ...entry]);
          }
        }
      } else {
        console.warn(
          `Alert history fetch failed for batch (${req.timeFrom}–${req.timeTo}): ${alertResp.reason || 'Unknown error'}`
        );
      }
    };

    // Execute with limited concurrency
    for (let i = 0; i < allRequests.length; i += concurrency) {
      const slice = allRequests.slice(i, i + concurrency);
      await Promise.all(slice.map(runBatch));
    }

    // Sort results
    allAlerts.sort((a, b) => b[2] - a[2]);
    return allAlerts;
  },
  async getAlers(limit = 50, page = 1, type = "history", aptNumber = "") {
    let allAlerts = [];

    if (type === "current") {
      const now = Math.floor(Date.now() / 1000);
      if (now - this.lastSynced > 120) {
        this.lastSynced = now;
        this.propertyData.currentAlerts = await this._fetchAlerts(
          this.propertyData.meterIds,
          this.propertyData.property,
          "current"
        );
      }
      allAlerts = this.propertyData.currentAlerts || [];
    } else {
      allAlerts = this.propertyData.alerts || [];
    }

    const formatAlerts = allAlerts.map(
      ([mid, alertType, startTime, endTime, quantity]) => {
        let aptNo = "",
          location = "",
          has_valve = 0;
        for (const unitName in this.propertyData.units) {
          const unit = this.propertyData.units[unitName];
          for (const loc in unit.meterLocations) {
            const meter = unit.meterLocations[loc];
            if (meter.mid === mid) {
              aptNo = unitName;
              location = loc;
              has_valve = meter.has_valve ? 1 : 0;
            }
          }
        }

        const startDate = new Date(startTime * 1000);
        const endDate = endTime ? new Date(endTime * 1000) : null;
        const durationMin = endDate
          ? Math.round((endTime - startTime) / 60)
          : null;
        const dateStr = startDate.toISOString().split("T")[0];
        const timeStr = startDate.toTimeString().split(" ")[0];

        return {
          date: dateStr,
          time: timeStr,
          alertType,
          meterId: mid,
          aptNo,
          location,
          svrDateTime: `${dateStr} ${timeStr}`,
          duration: durationMin != null ? durationMin.toString() : undefined,
          quantity: quantity != null ? quantity.toString() : undefined,
          has_valve,
        };
      }
    );

    const filtered = aptNumber
      ? formatAlerts.filter((f) => f.aptNo === aptNumber)
      : formatAlerts;
    const offset = (page - 1) * limit;
    const result = filtered.slice(offset, offset + limit);

    return {
      response_data: {
        alerts: result,
        TotalCount: filtered.length,
        societyId: this.propertyData.property || "UNKNOWN",
        page: page,
      },
      count: result.length,
      message: "",
      error: "",
      status: "Success",
    };
  },
  async getValveStatusForUnit(unitName) {
    const unit = this.propertyData?.units?.[unitName];
    if (!unit) return { status: "Fail", message: "Invalid unit name" };

    const { meterIds, meterIdMap } = this._getMeterDetailsForUnit(unitName);
    const now = Math.floor(Date.now() / 1000);

    const commonPayload = {
      meterIds,
      property: this.propertyData.property,
      token: this.token,
      timeFrom: 0,
      timeTo: now + 100,
    };

    const [statusResp, historyResp] = await Promise.all([
      this.post("ValveStatus", commonPayload),
      this.post("ValveCommandHistory", commonPayload),
    ]);

    const valveFlow =
      statusResp.status === "ok" && statusResp.Flow ? statusResp.Flow : {};
    const history =
      historyResp.status === "ok" && historyResp.History
        ? historyResp.History
        : {};

    const meterLocations = unit.meterLocations || {};

    const rows = meterIds.map((mid) => {
      const location = meterIdMap[mid] || "-";
      let valveStatus = "NA";
      let action = null,
        actionReason = null,
        login = null,
        status = null,
        time = null;

      // Determine if valve exists for this meter from the unit data
      let valveExists = false;
      if (location && meterLocations[location]) {
        const hv = meterLocations[location].has_valve;
        if (hv === 1 || hv === "1") valveExists = true;
      }

      // if (valveFlow[mid]) {
      //   const [tsStr, flowEntry] = Object.entries(valveFlow[mid])[0] || [];
      //   if (flowEntry) {
      //     const tsNum = parseInt(tsStr, 10);
      //     const code = flowEntry[0];
      //     valveStatus = code === "O" ? "Open" : code === "C" ? "Closed" : "NA";
      //     // Not setting time here as it's available in history logic
      //   }
      // }
      if (valveFlow[mid]) {
        const entries = Object.entries(valveFlow[mid]);
        if (entries.length > 0) {
          // Sort timestamps descending and pick latest
          const [latestTs, flowEntry] = entries.sort(
            (a, b) => parseInt(b[0]) - parseInt(a[0])
          )[0];
          const code = flowEntry[0];
          valveStatus = code === "O" ? "Open" : code === "C" ? "Closed" : "NA";
        }
      }

      if (history[mid] && history[mid].length > 0) {
        const [histTime, , cmd, , who] = history[mid].reduce((a, b) =>
          a[0] > b[0] ? a : b
        );
        action = cmd === "open" ? "C" : "A";
        actionReason = who;
        login = who;

        const ts = histTime;
        time = this._formatUnixTime(ts, {
          timeZone: "Asia/Kolkata",
          hour12: false,
        });

        let updatedStatus = false;
        if (valveFlow[mid]) {
          for (const tsStr in valveFlow[mid]) {
            const tsNum = parseInt(tsStr, 10);
            if (tsNum > histTime) {
              const [code] = valveFlow[mid][tsStr];
              if (
                (cmd === "open" && code === "O") ||
                (cmd === "close" && code === "C")
              ) {
                status = 0;
                updatedStatus = true;
                break;
              }
            }
          }
        }

        if (!updatedStatus) {
          const elapsed = now - histTime;
          status = elapsed <= 300 ? 2 : -4;
        }
      }

      return {
        valveExists,
        meterId: mid,
        location,
        locationUser: location,
        actionReason,
        action,
        time,
        login,
        valveStatus,
        status,
      };
    });

    return {
      response_data: { count: rows.length, rows },
      error: "",
      message: "",
      status: "Success",
    };
  },

  async getValveHistoryForUnit(unitName) {
    const unit = this.propertyData?.units?.[unitName];
    if (!unit) return { status: "Fail", message: "Invalid unit name." };

    const { meterIds, meterIdMap } = this._getMeterDetailsForUnit(unitName);
    const now = Math.floor(Date.now() / 1000);

    const payload = {
      meterIds,
      property: this.propertyData.property,
      token: this.token,
      timeFrom: 0,
      timeTo: now + 100,
    };

    const [commandResp, statusResp] = await Promise.all([
      this.post("ValveCommandHistory", payload),
      this.post("ValveStatusHistory", payload),
    ]);

    if (commandResp.status !== "ok" || statusResp.status !== "ok") {
      return { status: "Fail", message: "Failed to retrieve valve history." };
    }

    const commandHistory = commandResp.History || {};
    const statusHistory = statusResp.History || {};
    const result = [];

    for (const mid of meterIds) {
      const location = meterIdMap[mid] || "-";
      const aptNo = unitName;
      const cmdEntries = commandHistory[mid] || [];
      const statusEntries = statusHistory[mid] || [];

      for (const [cmdTime, , cmd, , who] of cmdEntries) {
        const initiated = this._formatUnixTime(cmdTime);
        const expected = cmd === "open" ? "O" : "C";
        let message = "Timed Out";
        let updated = "-";

        for (const [ts, code] of statusEntries) {
          if (ts > cmdTime && ts <= cmdTime + 300) {
            updated = this._formatUnixTime(ts);
            message = code === expected ? `Valve is ${cmd}` : "Failed";
            break;
          }
        }

        if (message === "Timed Out" && cmdTime + 300 > now) message = "Waiting";

        result.push({
          initiated,
          action: cmd.charAt(0).toUpperCase() + cmd.slice(1),
          location,
          userInterface: who,
          message,
          aptNo,
          updated,
        });
      }
    }

    result.sort((a, b) => new Date(b.initiated) - new Date(a.initiated));

    return {
      response_data: {
        valvehistory: result,
        societyId: this.propertyData.property,
        apartmentId: unitName,
      },
      message: "",
      status: "Success",
    };
  },

  async operateValve(meterId, command) {
    if (!this.propertyData?.property || !this.token) {
      return {
        message: "Authentication or property data missing.",
        error: "Missing data",
        status: "Fail",
      };
    }

    const response = await this.post("Valve", {
      meterIds: [meterId],
      command: command.toLowerCase(),
      property: this.propertyData.property,
      token: this.token,
    });

    if (response.status === "ok") {
      return {
        message: "Valve action succeeded.",
        status: "Success",
        error: "",
      };
    }

    return {
      message: "Valve action failed.",
      status: "Fail",
      error: response.reason || "Unknown error",
    };
  },

  async getInvoices(property) {
    if (!property || !this.token) {
      return {
        message: "Authentication or property data missing.",
        status: "Fail",
        error: "Missing data",
      };
    }

    try {
      const response = await this.post("InvoiceList", {
        property: property,
        token: this.token,
      });

      if (response.status === "ok") {
        return {
          message: "Invoice list fetched successfully.",
          status: "Success",
          data: response.resp,
          error: "",
        };
      }

      return {
        message: "Failed to fetch invoice list.",
        status: "Fail",
        error: response.reason || "Unknown error",
      };
    } catch (err) {
      return {
        message: "Exception while fetching invoice list.",
        status: "Fail",
        error: err.message || err,
      };
    }
  },

  async getInvoicePDF(invoiceDate) {
    let property = this.propertyData.property;
    if (!property || !this.token || !invoiceDate) {
      return {
        message: "Required data missing: property or invoiceDate.",
        status: "Fail",
        error: "Missing data",
      };
    }

    try {
      const response = await this.post("InvoicePDF", {
        property: property,
        InvoiceMonth: invoiceDate,
        token: this.token,
      });

      if (response.status === "ok") {
        return {
          message: "Invoice PDF URL fetched successfully.",
          status: "Success",
          data: response.resp, // PDF URL
          error: "",
        };
      }

      return {
        message: "Failed to fetch invoice PDF.",
        status: "Fail",
        error: response.reason || "Unknown error",
      };
    } catch (err) {
      return {
        message: "Exception while fetching invoice PDF.",
        status: "Fail",
        error: err.message || err,
      };
    }
  },
  // ---------------- Water Bill APIs ------------------

  async generateWaterBill(property) {
    if (!property || !this.token) {
      return {
        message: "Required data missing: property or token.",
        status: "Fail",
        error: "Missing data",
      };
    }

    try {
      const response = await this.post("GenerateWaterBill", {
        property: property,
        token: this.token,
        timeout: 120000, // <-- override timeout to 2 minutes
      });

      if (response.status === "ok") {
        return {
          message: "Water bill generated successfully.",
          status: "Success",
          error: "",
        };
      }

      return {
        message: "Failed to generate water bill.",
        status: "Fail",
        error: response.reason || "Unknown error",
      };
    } catch (err) {
      return {
        message: "Exception while generating water bill.",
        status: "Fail",
        error: err.message || err,
      };
    }
  },

  async getWaterBill(property, unitName, cycleDate) {
    if (!property || !this.token || !unitName || !cycleDate) {
      return {
        message: "Required data missing: property, unitName or cycleDate.",
        status: "Fail",
        error: "Missing data",
      };
    }

    try {
      const response = await this.post("GetWaterBill", {
        property: property,
        unitName: unitName,
        cycleDate: cycleDate,
        token: this.token,
      });

      if (response.status === "ok") {
        return {
          message: "Water bill fetched successfully.",
          status: "Success",
          data: response.html, // HTML content
          error: "",
        };
      }

      return {
        message: "Failed to fetch water bill.",
        status: "Fail",
        error: response.reason || "Unknown error",
      };
    } catch (err) {
      return {
        message: "Exception while fetching water bill.",
        status: "Fail",
        error: err.message || err,
      };
    }
  },

  async updateWaterBillPayment(property, unitName, paymentData) {
    if (!property || !this.token || !unitName || !paymentData) {
      return {
        message: "Required data missing: property, unitName, or paymentData.",
        status: "Fail",
        error: "Missing data",
      };
    }

    try {
      const response = await this.post("UpdateWaterBillPayment", {
        property: property,
        unitName: unitName,
        ...paymentData,
        token: this.token,
      });

      if (response.status === "ok") {
        return {
          message: "Water bill payment updated successfully.",
          status: "Success",
          error: "",
        };
      }

      return {
        message: "Failed to update water bill payment.",
        status: "Fail",
        error: response.reason || "Unknown error",
      };
    } catch (err) {
      return {
        message: "Exception while updating water bill payment.",
        status: "Fail",
        error: err.message || err,
      };
    }
  },

  async emailWaterBill(property, unitName) {
    if (!property || !this.token || !unitName) {
      return {
        message: "Required data missing: property or unitName.",
        status: "Fail",
        error: "Missing data",
      };
    }

    try {
      const response = await this.post("EmailWaterBill", {
        property: property,
        unitName: unitName,
        token: this.token,
      });

      if (response.status === "ok") {
        return {
          message: "Water bill emailed successfully.",
          status: "Success",
          error: "",
        };
      }

      return {
        message: "Failed to email water bill.",
        status: "Fail",
        error: response.reason || "Unknown error",
      };
    } catch (err) {
      return {
        message: "Exception while emailing water bill.",
        status: "Fail",
        error: err.message || err,
      };
    }
  },

  async sendBills(property) {
    if (!property || !this.token) {
      return {
        message: "Required data missing: property.",
        status: "Fail",
        error: "Missing data",
      };
    }
    try {
      const response = await this.post("EmailWaterBill", {
        property: property?.societyName,
        token: this.token,
        ...(property?.unitName && { unitName: property.unitName }),
      });
      if (response.status === "ok") {
        return {
          message: "Water bill emailed successfully.",
          status: "Success",
          error: "",
        };
      }

      return {
        message: "Failed to email water bill.",
        status: "Fail",
        error: response.reason || "Unknown error",
      };
    } catch (err) {
      return {
        message: "Exception while emailing water bill.",
        status: "Fail",
        error: err.message || err,
      };
    }
  },

  async waterBillSettings(property, settingsData = {}) {
    if (!property || !this.token) {
      return {
        message: "Required data missing: property or token.",
        status: "Fail",
        error: "Missing data",
      };
    }

    try {
      const response = await this.post("Settings", {
        property: property,
        token: this.token,
        settings: settingsData,
      });

      if (response.status === "ok") {
        return {
          message: "Water bill settings fetched successfully.",
          status: "Success",
          data: response.settings,
          error: "",
        };
      }

      return {
        message: "Failed to fetch water bill settings.",
        status: "Fail",
        error: response.reason || "Unknown error",
      };
    } catch (err) {
      return {
        message: "Exception while fetching water bill settings.",
        status: "Fail",
        error: err.message || err,
      };
    }
  },

  async getWaterBillHistory(property, unitName) {
    if (!property || !this.token) {
      return {
        message: "Required data missing: property or token.",
        status: "Fail",
        error: "Missing data",
      };
    }

    try {
      const response = await this.post("GetWBillHistory", {
        property: property,
        unitName: unitName,
        token: this.token,
      });

      if (response.status === "ok") {
        return {
          message: "Water bill history fetched successfully.",
          status: "Success",
          data: response.history,
          error: "",
        };
      }

      return {
        message: "Failed to fetch water bill history.",
        status: "Fail",
        error: response.reason || "Unknown error",
      };
    } catch (err) {
      return {
        message: "Exception while fetching water bill history.",
        status: "Fail",
        error: err.message || err,
      };
    }
  },
  async getManagementTeam(property) {
    if (!property || !this.token) {
      return {
        response_data: {},
        message: "Required data missing: property or token.",
        error: "Missing data",
        status: "Fail",
      };
    }

    try {
      const response = await this.post("GetManagmentTeam", {
        property: property,
        token: this.token,
      });

      if (response.status === "ok" && Array.isArray(response.reason)) {
        savedMembers = response.reason.map((m, index) => ({
          contactId: index + 1,
          name: m.member_name || "",
          mobile: m.phone || "",
          designation: m.role || "",
          email: m.email || "",
          start: m.tenure_start || "",
          end: m.tenure_end || "",
        }));

        return {
          response_data: {
            members: savedMembers,
            societyId: property,
          },
          message: "",
          error: "",
          status: "Success",
        };
      }

      savedMembers = [];
      return {
        response_data: {},
        message: "Failed to fetch management team.",
        error: response.reason || "Unknown error",
        status: "Fail",
      };
    } catch (err) {
      savedMembers = [];
      return {
        response_data: {},
        message: "Exception while fetching management team.",
        error: err.message || err,
        status: "Fail",
      };
    }
  },

  async setManagementTeam(property, mteam) {
    if (
      !property ||
      !this.token ||
      !Array.isArray(mteam) ||
      mteam.length === 0
    ) {
      return {
        response_data: {},
        message:
          "Required data missing: property, token or management team list.",
        error: "Missing or invalid data",
        status: "Fail",
      };
    }

    try {
      const response = await this.post("SetManagmentTeam", {
        property: property,
        mteam: mteam,
        token: this.token,
      });

      if (response.status === "ok") {
        return {
          response_data: { societyId: property },
          message: "Management team updated successfully.",
          error: "",
          status: "Success",
        };
      }

      return {
        response_data: {},
        message: "Failed to update management team.",
        error: response.reason || "Unknown error",
        status: "Fail",
      };
    } catch (err) {
      return {
        response_data: {},
        message: "Exception while updating management team.",
        error: err.message || err,
        status: "Fail",
      };
    }
  },

  async UpdateRwaMembersApi(data) {
    const property = this.propertyData.property;
    const index = savedMembers.findIndex((m) => m.contactId === data.contactId);

    if (index !== -1) {
      savedMembers[index] = { ...savedMembers[index], ...data };
    } else {
      console.warn(`Member ${data.contactId} not found.`);
    }

    const mteam = savedMembers.map((m) => ({
      member_name: m.name,
      phone: this.formatPhoneNumber(m.mobile),
      role: m.designation,
      email: m.email,
      tenure_start: m.start || "",
      tenure_end: m.end || "",
    }));

    return await this.setManagementTeam(property, mteam);
  },

  async PostInsertRwaMembersApi(data) {
    const property = data.societyId;
    if (!Array.isArray(data.members))
      return { status: "Fail", error: "No members provided" };

    const nextId = savedMembers.length + 1;
    const newMembers = data.members.map((m, i) => ({
      contactId: nextId + i,
      name: m.name,
      mobile: m.mobile,
      designation: m.designation,
      email: m.email,
      start: m.start || "",
      end: m.end || "",
    }));

    savedMembers.push(...newMembers);

    const mteam = savedMembers.map((m) => ({
      member_name: m.name,
      phone: this.formatPhoneNumber(m.mobile),
      role: m.designation,
      email: m.email,
      tenure_start: m.start || "",
      tenure_end: m.end || "",
    }));

    return await this.setManagementTeam(property, mteam);
  },

  formatPhoneNumber(number) {
    number = number.replace(/[^0-9]/g, "");
    if (number.startsWith("91") && number.length === 12) {
      number = "+" + number;
    }
    return number;
  },

  async DeleteRwaMembersApi(data) {
    const property = this.propertyData.property;
    savedMembers = savedMembers.filter((m) => m.contactId !== data.contactId);

    const mteam = savedMembers.map((m) => ({
      member_name: m.name,
      phone: this.formatPhoneNumber(m.mobile),
      role: m.designation,
      email: m.email,
      tenure_start: m.start || "",
      tenure_end: m.end || "",
    }));

    return await this.setManagementTeam(property, mteam);
  },

  async getSourceEntries(property, from, to) {
    if (!property || !this.token) {
      return {
        message: "Required data missing: property or token.",
        status: "Fail",
        error: "Missing data",
      };
    }

    try {
      const response = await this.post("GetSourceEntries", {
        property: property,
        from: from,
        to: to,
        // from: "2025-05-01 00:00:00",
        // to: "2025-10-28 23:59:59",
      });

      if (response.status === "ok") {
        return {
          message: "Purchase data fetched successfully.",
          status: "Success",
          data: response.sources,
          error: "",
        };
      }

      return {
        message: "Failed to fetch purchase data.",
        status: "Fail",
        error: response.reason || "Unknown error",
      };
    } catch (err) {
      return {
        message: "Exception while fetching purchase data.",
        status: "Fail",
        error: err.message || err,
      };
    }
  },

  async addSourceEntries(property, data) {
    if (!property || !this.token) {
      return {
        message: "Required data missing: property or token.",
        status: "Fail",
        error: "Missing data",
      };
    }

    try {
      const response = await this.post("AddSourceEntry", {
        property: property,
        WaterSourceEntry: data,
      });

      if (response.status === "ok") {
        return {
          message: "Purchase data added successfully.",
          status: "Success",
          data: response,
          error: "",
        };
      }

      return {
        message: "Failed to add purchase data.",
        status: "Fail",
        error: response.reason || "Unknown error",
      };
    } catch (err) {
      return {
        message: "Exception while adding purchase data.",
        status: "Fail",
        error: err.message || err,
      };
    }
  },

  async getAllTickets(property) {
    if (!property || !this.token) {
      return {
        message: "Required data missing: property or token.",
        status: "Fail",
        error: "Missing data",
      };
    }

    try {
      const response = await this.post("FreshDesk", {
        property: property,
        token: this.token,
        arguments: {
          api: "alltickets",
          Payload: { societyName: property },
        },
      });

      if (response.status === "ok") {
        return {
          message: "All tickets fetched successfully.",
          status: "Success",
          data: response.response,
          error: "",
        };
      }

      return {
        message: "Failed to fetch tickets",
        status: "Fail",
        error: response.reason || "Unknown error",
      };
    } catch (err) {
      return {
        message: "Exception while fetching tickets.",
        status: "Fail",
        error: err.message || err,
      };
    }
  },

  async createTicket(data) {
    if (!data || !this.token) {
      return {
        message: "Required data missing: property or token.",
        status: "Fail",
        error: "Missing data",
      };
    }

    try {
      const response = await this.post("FreshDesk", {
        property: data?.societyName,
        token: this.token,
        arguments: {
          api: "createticket",
          Payload: data?.requestData,
        },
      });

      if (response.status === "ok") {
        return {
          message: "Ticket created successfully.",
          status: "Success",
          data: response.response,
          error: "",
        };
      }

      return {
        message: "Failed to create ticket",
        status: "Fail",
        error: response.reason || "Unknown error",
      };
    } catch (err) {
      return {
        message: "Exception while create ticket.",
        status: "Fail",
        error: err.message || err,
      };
    }
  },

  async getChatHistory(property, data) {
    if (!property || !this.token || !data) {
      return {
        message: "Required data missing: property or token.",
        status: "Fail",
        error: "Missing data",
      };
    }

    try {
      const response = await this.post("FreshDesk", {
        property: property,
        token: this.token,
        arguments: {
          api: "ticketconversation",
          Payload: data,
        },
      });

      if (response.status === "ok") {
        return {
          message: "All chat fetched successfully.",
          status: "Success",
          data: response.response,
          error: "",
        };
      }

      return {
        message: "Failed to fetch chats",
        status: "Fail",
        error: response.reason || "Unknown error",
      };
    } catch (err) {
      return {
        message: "Exception while fetching chats.",
        status: "Fail",
        error: err.message || err,
      };
    }
  },

  async getTicketById(property, data) {
    if (!property || !this.token || !data) {
      return {
        message: "Required data missing: property or token.",
        status: "Fail",
        error: "Missing data",
      };
    }

    try {
      const response = await this.post("FreshDesk", {
        property: property,
        token: this.token,
        arguments: {
          api: "ticket",
          Payload: data,
        },
      });

      if (response.status === "ok") {
        return {
          message: "All chat fetched successfully.",
          status: "Success",
          data: response.response,
          error: "",
        };
      }

      return {
        message: "Failed to fetch chats",
        status: "Fail",
        error: response.reason || "Unknown error",
      };
    } catch (err) {
      return {
        message: "Exception while fetching chats.",
        status: "Fail",
        error: err.message || err,
      };
    }
  },

  async createTicketReply(property, data) {
    if (!data || !property || !this.token) {
      return {
        message: "Required data missing: property or token.",
        status: "Fail",
        error: "Missing data",
      };
    }

    try {
      const response = await this.post("FreshDesk", {
        property: property,
        token: this.token,
        arguments: {
          api: "ticketreply",
          Payload: data,
        },
      });

      if (response.status === "ok") {
        return {
          message: "Ticket reply created successfully.",
          status: "Success",
          data: response.response,
          error: "",
        };
      }

      return {
        message: "Failed to create ticket reply",
        status: "Fail",
        error: response.reason || "Unknown error",
      };
    } catch (err) {
      return {
        message: "Exception while create ticket reply.",
        status: "Fail",
        error: err.message || err,
      };
    }
  },

  async getSupportAgents(property) {
    if (!property || !this.token) {
      return {
        message: "Required data missing: property or token.",
        status: "Fail",
        error: "Missing data",
      };
    }

    try {
      const response = await this.post("FreshDesk", {
        property: property,
        token: this.token,
        arguments: {
          api: "agents",
          // Payload: data,
        },
      });

      if (response.status === "ok") {
        return {
          message: "All agent fetched successfully.",
          status: "Success",
          data: response.response,
          error: "",
        };
      }

      return {
        message: "Failed to fetch agents",
        status: "Fail",
        error: response.reason || "Unknown error",
      };
    } catch (err) {
      return {
        message: "Exception while fetching agents.",
        status: "Fail",
        error: err.message || err,
      };
    }
  },

  async getSupportContacts(property) {
    if (!property || !this.token) {
      return {
        message: "Required data missing: property or token.",
        status: "Fail",
        error: "Missing data",
      };
    }

    try {
      const response = await this.post("FreshDesk", {
        property: property,
        token: this.token,
        arguments: {
          api: "contacts",
          // Payload: data,
        },
      });

      if (response.status === "ok") {
        return {
          message: "All agent fetched successfully.",
          status: "Success",
          data: response.response,
          error: "",
        };
      }

      return {
        message: "Failed to fetch agents",
        status: "Fail",
        error: response.reason || "Unknown error",
      };
    } catch (err) {
      return {
        message: "Exception while fetching agents.",
        status: "Fail",
        error: err.message || err,
      };
    }
  },

  async getApartmentByUnit(property, unit) {
    if (!property || !this.token) {
      return {
        message: "Required data missing: property or token.",
        status: "Fail",
        error: "Missing data",
      };
    }

    try {
      const response = await this.post("Residents", {
        property: property,
        token: this.token,
        unitName: unit,
      });

      if (response.status === "ok") {
        // ---------------------------------------------------
        // ✅ NEW: Update the global state if it exists
        // ---------------------------------------------------
        if (this.propertyData && this.propertyData.units) {
          this._attachResidents(response, this.propertyData.units);
        }
        const residentsArr = this._parseResidentsCSV(response.Residents);
        return {
          message: "Resident details fetched successfully.",
          status: "Success",
          data: residentsArr,
          error: "",
        };
      }
      return {
        message: "Failed to fetch resident detail",
        status: "Fail",
        error: response.reason || "Unknown error",
      };
    } catch (err) {
      return {
        message: "Exception while fetching resident detail.",
        status: "Fail",
        error: err.message || err,
      };
    }
  },

  async updateResidentData(property, residentData) {
    if (!property || !this.token) {
      return {
        message: "Required data missing: property or token.",
        status: "Fail",
        error: "Missing data",
      };
    }

    try {
      const response = await this.post("Residents", {
        token: this.token,
        property: property,
        unitName: residentData[0].unit,
        Residents: residentData,
      });

      if (response.status === "ok") {
        // ---------------------------------------------------
        // ✅ NEW: Update the global state if it exists
        // ---------------------------------------------------
        if (this.propertyData && this.propertyData.units) {
          this._attachResidents(response, this.propertyData.units);
        }
        const residentsArr = this._parseResidentsCSV(response.Residents);
        return {
          message: "Resident details added successfully.",
          status: "Success",
          data: residentsArr,
          error: "",
        };
      }

      return {
        message: "Failed to add resident detail",
        status: "Fail",
        error: response.reason || "Unknown error",
      };
    } catch (err) {
      return {
        message: "Exception while adding resident detail.",
        status: "Fail",
        error: err.message || err,
      };
    }
  },

  async adminLock(property, data) {
    if (!property || !this.token) {
      return {
        message: "Required data missing: property or token.",
        status: "Fail",
        error: "Missing data",
      };
    }

    try {
      const response = await this.post("AdminLock", {
        token: this.token,
        property: property,
        status: data?.status,
        unitName: data.unit,
        message: data?.comment,
      });

      if (response.status === "ok") {
        const uInfo = this.propertyData.uinfo || {};

        if (uInfo.hasOwnProperty(data.unit)) {
          delete this.propertyData.uinfo[data.unit];
        } else {
          const newUinfo = { [data.unit]: { admin_lock: true } };
          this.propertyData = {
            ...this.propertyData,
            uinfo: {
              ...this.propertyData.uinfo,
              ...newUinfo,
            },
          };
        }

        return {
          message: "Admin lock updated successfully.",
          status: "Success",
          data: response,
          error: "",
        };
      }

      return {
        message: "Failed to update admin lock",
        status: "Fail",
        error: response.reason || "Unknown error",
      };
    } catch (err) {
      return {
        message: "Exception while update admin lock.",
        status: "Fail",
        error: err.message || err,
      };
    }
  },

  async getFmUsers(property) {
    if (!property || !this.token) {
      return {
        message: "Required data missing: property or token.",
        status: "Fail",
        error: "Missing data",
      };
    }

    try {
      const response = await this.post("FMUsers", {
        property: property,
        token: this.token,
      });

      if (response.status === "ok") {
        return {
          message: "All FM users fetched successfully.",
          status: "Success",
          data: response.fmusers,
          error: "",
        };
      }

      return {
        message: "Failed to fetch FM users",
        status: "Fail",
        error: response.reason || "Unknown error",
      };
    } catch (err) {
      return {
        message: "Exception while fetching FM users.",
        status: "Fail",
        error: err.message || err,
      };
    }
  },

  async getSourceMeterReadings(data) {
    if (!data?.property || !this.token) {
      return {
        message: "Required data missing: property or token.",
        status: "Fail",
        error: "Missing data",
      };
    }

    try {
      const response = await this.post("SourceMeterReadings", {
        property: data?.property,
        token: this.token,
        meterId: data?.meterId,
        start: data?.start,
        end: data?.end,
      });

      if (response.status === "ok") {
        return {
          message: "Source Meter Readings fetched successfully.",
          status: "Success",
          data: response,
          error: "",
        };
      }

      return {
        message: "Failed to fetch Source Meter Readings",
        status: "Fail",
        error: response.reason || "Unknown error",
      };
    } catch (err) {
      return {
        message: "Exception while fetching Source Meter Readings.",
        status: "Fail",
        error: err.message || err,
      };
    }
  },

  async getPaymentsApi(data) {
    if (!data || !this.token) {
      return {
        message: "Required data missing: property or token.",
        status: "Fail",
        error: "Missing data",
      };
    }

    try {
      const response = await this.post("GetWaterBillPayments", {
        property: data?.property,
        token: this.token,
        userName: data.userName,
        unitName: data?.unitName,
        from_epoch: data.fromEpoch,
        to_epoch: data.toEpoch,
      });
      if (response.status === "ok") {
        return {
          message: "Payments fetched successfully.",
          status: "Success",
          data: response?.data,
          error: "",
        };
      }

      return {
        message: "Failed to fetch Payments",
        status: "Fail",
        error: response.reason || "Unknown error",
      };
    } catch (err) {
      return {
        message: "Exception while fetching Payments.",
        status: "Fail",
        error: err.message || err,
      };
    }
  },

  async updatePaymentApi(data) {
    if (!data || !this.token) {
      return {
        message: "Required data missing: property or token.",
        status: "Fail",
        error: "Missing data",
      };
    }

    try {
      const response = await this.post("AddWaterBillPayment", {
        property: data?.property,
        token: this.token,
        userName: data.userName,
        unitName: data?.unitName,
        paid_amount: data.paid_amount,
        payment_mode: data.payment_mode,
        payment_epoch: data.payment_epoch,
      });

      if (response.status === "ok") {
        return {
          message: "Payments updated successfully.",
          status: "Success",
          data: response?.data,
          error: "",
        };
      }

      return {
        message: "Failed to update Payments",
        status: "Fail",
        error: response.reason || "Unknown error",
      };
    } catch (err) {
      return {
        message: "Exception while updating Payments.",
        status: "Fail",
        error: err.message || err,
      };
    }
  },

  async logout(property) {
    if (!property || !this.token) {
      return {
        message: "Required data missing: property or token.",
        status: "Fail",
        error: "Missing data",
      };
    }

    try {
      const response = await this.post("Logout", {
        token: this.token,
        property: property,
      });

      if (response.status === "ok") {
        return {
          message: "Logout successfully.",
          status: "Success",
          data: response,
          error: "",
        };
      }

      return {
        message: "Failed to logout",
        status: "Fail",
        error: response.reason || "Unknown error",
      };
    } catch (err) {
      return {
        message: "Exception while logout.",
        status: "Fail",
        error: err.message || err,
      };
    }
  },

  // Add any other method (getValveStatusForUnit, getValveHistoryForUnit, operateValve) similarly using `unit.meterLocations`
};

export default NeoAPI;
